      (function() {
        var dropdownSelector = '.dropdown-menu.bq-header-dropdown';

        function getHeaderDropdownTop() {
          var anchor = document.querySelector('.header__wrapper') || document.querySelector('store-header.header') || document.querySelector('.shopify-section--header');

          if (!anchor) {
            return 0;
          }

          return anchor.getBoundingClientRect().bottom;
        }

        function positionHeaderDropdowns() {
          var viewportTop = Math.max(0, getHeaderDropdownTop());
          var header = document.querySelector('store-header.header') || document.querySelector('.header');
          var headerTop = header ? header.getBoundingClientRect().top : 0;
          var top = Math.max(0, viewportTop - headerTop);

          document.documentElement.style.setProperty('--bq-header-dropdown-top', top.toFixed(2) + 'px');

          document.querySelectorAll(dropdownSelector).forEach(function(menu) {
            var details = menu.closest('details');
            var trigger = details ? details.querySelector('summary') : null;

            if (!trigger) {
              return;
            }

            var triggerRect = trigger.getBoundingClientRect();
            var styleWidth = parseFloat(getComputedStyle(menu).width);
            var width = Math.min(menu.offsetWidth || styleWidth || 218, window.innerWidth - 32);
            var x = triggerRect.left;

            x = Math.max(16, Math.min(window.innerWidth - 16 - width, x));
            menu.style.setProperty('--bq-header-dropdown-left', x.toFixed(2) + 'px');
          });
        }

        function scheduleHeaderDropdowns() {
          positionHeaderDropdowns();
          window.requestAnimationFrame(positionHeaderDropdowns);
          window.setTimeout(positionHeaderDropdowns, 80);
        }

        document.addEventListener('DOMContentLoaded', scheduleHeaderDropdowns);
        window.addEventListener('load', scheduleHeaderDropdowns);
        window.addEventListener('resize', scheduleHeaderDropdowns, { passive: true });
        window.addEventListener('scroll', scheduleHeaderDropdowns, { passive: true });
        document.addEventListener('pointerover', scheduleHeaderDropdowns, true);
        document.addEventListener('focusin', scheduleHeaderDropdowns, true);
        document.addEventListener('toggle', scheduleHeaderDropdowns, true);

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(scheduleHeaderDropdowns);
        }

        scheduleHeaderDropdowns();
      })();
